import analyticModule from './analyticModule'

const modules = {
  analyticModule,
}

export default {
  modules,
}
